import { BaseService, Resource } from '@app/core/services/base.service';
import { HttpClient } from '@angular/common/http';
import { FeatureSettingsDto } from '@app/generated/model';
import { Observable } from 'rxjs';
import { env } from '../../../environments/env';
import { Injectable } from '@angular/core';
import { ResourceType } from '@dwo/enums';

@Injectable({
  providedIn: 'root',
})
export class SettingsService extends BaseService {
  constructor(public http: HttpClient) {
    super(http);
  }

  @Resource(ResourceType.LoadSettings)
  loadSettings(): Observable<FeatureSettingsDto[]> {
    return this.http.get<FeatureSettingsDto[]>(`${env.get().api.url}/app/settings`);
  }
}
